import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { useAtom } from "jotai";
import { ChangeEvent, FC, useState } from "react";
import { modalForms } from "../../../atoms/atom";
import { FormService } from "../../../services/FormService";
import { FormDTO } from "../../../types/FormDTO";
import { useUtils } from "../../../utils/utilFunctions";
import { useAlert } from "../../contextProviders/AlertProvider";
import './ModalForm.scss';

const ModalForm: FC = () => {
	const [open, setOpen] = useAtom(modalForms);
	const [cnpj, setCnpj] = useState('');
	const [secondId, setSecondId] = useState('MATRICULA');
	const service = new FormService();
	const { showAlert, showError } = useAlert();
	const { validateCNPJ, formatDocument, validateCPF } = useUtils();

	const close = () => {
		setOpen(false);
		setCnpj('');
		setSecondId('MATRICULA');
	}

	return (
		<Dialog
			open={open}
			onClose={() => close()}
			id='modal-forms'
		>
			<DialogTitle>Novo formulário</DialogTitle>
			<DialogContent id="modal-forms-content">
				<TextField
					sx={{width: '300px !important'}}
					label="CPF/CNPJ"
					id="cnpj-form"
					size="medium"
					inputProps={{ maxLength: 18}}
					value={cnpj}
					onChange={(e: ChangeEvent<HTMLInputElement>) => setCnpj(formatDocument(e.target.value.trim()))}
					helperText="Insira o CPF/CNPJ da empresa"
					error={!!cnpj && !validateCNPJ(cnpj) && !validateCPF(cnpj)}
				/>
				<FormControl
					sx={{width: "300px"}}
				>
					<InputLabel id="template-select-label">
						Segundo identificador
					</InputLabel>
					<Select
						label="Segundo identificador"
						labelId="demo-simple-select-label"
						id="select-form-id"
						value={secondId}
						onChange={(e) => setSecondId(e.target.value)}
						size='medium'
					>
						<MenuItem
							key={'MATRICULA'}
							value={'MATRICULA'}
						>
							Matrícula
						</MenuItem>
						<MenuItem
							key={'RH_CODE'}
							value={'RH_CODE'}
						>
							Código RH
						</MenuItem>
						<MenuItem
							key={'EMPLOYEE_ID'}
							value={'EMPLOYEE_ID'}
						>
							Código do funcionário no SGG
						</MenuItem>
						<MenuItem
							key={'BIRTH_DATE'}
							value={'BIRTH_DATE'}
						>
							Data de nascimento
						</MenuItem>
					</Select>
				</FormControl>
			</DialogContent>
			<DialogActions>
				<Button id="close-form-button" onClick={() => close()}>
					Fechar
				</Button>
				<Button
					disabled={!validateCNPJ(cnpj) && !validateCPF(cnpj)}
					id="create-form-button"
					color="success"
					onClick={() => save()}
				>
					Salvar
				</Button>
			</DialogActions>
		</Dialog>
	);

	async function save() {
		try {
			const newForm = {
				cnpj: cnpj,
				secondId: secondId
			} as FormDTO;
			const response = await service.create(newForm);
			if (response?.status === 200) {
				showAlert('Formulário criado com sucesso', "success");
			} else {
				showError();
			}
		} catch (error) {
			showError();
		} finally {
			close();
		}
	}
}

export default ModalForm;